export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as 'development' | 'production'
export const SEGMENT_WRITE_KEY = process.env.REACT_APP_SEGMENT_WRITE_KEY as string
export const APP_VERSION = process.env.REACT_APP_VERSION as string
